import $ from 'jquery';

  var video_id = $('#player').attr('data-videoid');

      var tag = document.createElement('script');

      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // 3. This function creates an <iframe> (and YouTube player)
      //    after the API code downloads.
      var player;
      function onYouTubeIframeAPIReady() {
        player = new YT.Player('player', {
          height: '100%',
          width: '100%',
          videoId: video_id,
          playerVars: {
            'playsinline': 1
          },
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        //event.target.playVideo();
      }

      // 5. The API calls this function when the player's state changes.
      //    The function indicates that when playing a video (state=1),
      //    the player should play for six seconds and then stop.

      /*var done = false;
      function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.PLAYING && !done) {
          setTimeout(stopVideo, 6000);
          done = true;
        }
      }*/
      function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.PAUSED) {
            setTimeout(function() {
                if ( event.target.getPlayerState() == 2 ) {
                    $('.video-play-button').show();
                    $('.video-anteprima').show();
                }
            }, 500)
        }
        if (event.data == YT.PlayerState.ENDED) {
            $('.video-play-button').show();
            $('.video-anteprima').show();
        }
      }
      function stopVideo() {
        player.stopVideo();
      }

$('.video-play-button').on( "click", function() {
  $('.video-play-button').hide();
  $('.video-anteprima').hide();
  player.playVideo();
} );

$(window).load(function() {
  onYouTubeIframeAPIReady();
});


// WEBPACK FOOTER //
// ../views/blocks/video/video.js